export const FRONT_COLUMNS = (renderCell) => {
  return [
    {
      // title: '选择',
      dataIndex: 'selection',
      key: 'selection',
      align: 'center',
      stickyFixed: 'left',
      width: 50,
      scopedSlots: { title: "selectionTitle" },
      customRender: (value, row, index) => renderCell(value, row, index, ['supplierCode', 'itemCode'], true)
    },
    {
      title: '加工商编码',
      dataIndex: 'supplierCode',
      width: 75,
      stickyFixed: 'left',
      align: 'center',
      customRender: (value, row, index) => renderCell(value, row, index, ['supplierCode', 'itemCode'])
    },
    {
      title: '加工厂名称',
      dataIndex: 'supplierName',
      stickyFixed: 'left',
      width: 90,
      align: 'center',
      customRender: (value, row, index) => renderCell(value, row, index, ['supplierCode', 'itemCode'])
    },
    {
      title: '物料编码',
      dataIndex: 'itemCode',
      stickyFixed: 'left',
      width: 80,
      align: 'center',
      customRender: (value, row, index) => renderCell(value, row, index, ['supplierCode', 'itemCode'])
    },
    {
      title: '物料名称',
      dataIndex: 'itemName',
      stickyFixed: 'left',
      width: 90,
      align: 'center',
      customRender: (value, row, index) => renderCell(value, row, index, ['supplierCode', 'itemCode'])
      // ellipsis: true
    },
    {
      title: '目的仓',
      dataIndex: 'subinventory',
      stickyFixed: 'left',
      width: 70,
      align: 'center',
      customRender: (value, row, index) => renderCell(value, row, index, ['supplierCode', 'itemCode']),
      ellipsis: true
    },
    {
      title: 'V仓库存',
      dataIndex: 'vinventoryQty',
      stickyFixed: 'left',
      width: 70,
      align: 'center',
      customRender: (value, row, index) => renderCell(value, row, index, ['supplierCode', 'itemCode'])
    },
    {
      title: '关联成品编码',
      dataIndex: 'assemblyItemCode',
      stickyFixed: 'left',
      width: 80,
      align: 'center',
      customRender: (value, row, index) => renderCell(value, row, index, ['supplierCode', 'itemCode'])
    },
    {
      title: '关联成品规格',
      dataIndex: 'assemblyItemSpecification',
      stickyFixed: 'left',
      width: 130,
      align: 'center',
      ellipsis: true,
      customRender: (value, row, index) => renderCell(value, row, index, ['supplierCode', 'itemCode'])
    },
    { title: '项目', dataIndex: 'projectName', stickyFixed: 'left', align: 'center', width: 90 },
    { title: '初始', dataIndex: 'initialQty', align: 'center', width: 90 }
  ]
}
